
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/login",
      function () {
        return require("private-next-pages/account/login/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/login"])
      });
    }
  